import React from "react"
import Wrapper from "./bootcampvideoreview.style"
import linkedin from "../../../images/linkedin.svg"
import ReactPlayer from "react-player/youtube"
// import "slick-carousel/slick/slick.css"
// import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"
import styled from "styled-components"

function BootcampVideoReview({ data, fivek, className }) {
  var settings = {
    dots: true,
    infinite: true,
    pauseOnHover: true,
    centerPadding: "10px",
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return fivek ? (
    <Wrapper1>
      <div className="bootcamp_video_review_heading">
        {!fivek ? (
          <h2 style={{ fontSize: "26px" }}>video reviews</h2>
        ) : (
          <h2 className="fivek_h2">video reviews</h2>
        )}
      </div>
      <div className="bootcamp_video_reviews_wrapper">
        <Slider {...settings}>
          {data.video_reviews.map((d) => (
            <div className="bootcamp_video_reviews_section">
              {d.video_link ? (
                <lite-youtube
                  style={{ borderRadius: "6px" }}
                  params="controls=0&enablejsapi=1"
                  videoplay="Mirar"
                  videoid={d.video_link}
                ></lite-youtube>
              ) : null}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "#F5F4FD",
                  width: "100%",
                  padding: "0px 20px",
                  paddingBottom: "15px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: "6px",
                }}
              >
                <div className="name_surname">
                  <h3>{d.name}</h3>
                  <h5>{d.designation}</h5>
                </div>
                <div className="linkedin_section">
                  <a href="https://certisured.com/">
                    <img
                      style={{ width: "30px", height: "30px" }}
                      src={linkedin}
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </Wrapper1>
  ) : (
    <Wrapper>
      <div className="bootcamp_video_review_heading">
        {!fivek ? (
          <h2 style={{ fontSize: "26px" }}>video reviews</h2>
        ) : (
          <h2 className="fivek_h2">video reviews</h2>
        )}
      </div>
      <div className="bootcamp_video_reviews_wrapper">
        <Slider {...settings}>
          {data.video_reviews.map((d) => (
            <div className="bootcamp_video_reviews_section">
              <lite-youtube
                style={{ borderRadius: "6px" }}
                params="controls=0&enablejsapi=1"
                videoplay="Mirar"
                videoid={d.video_link}
              ></lite-youtube>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  backgroundColor: "#F5F4FD",
                  width: "100%",
                  padding: "0px 20px",
                  paddingBottom: "15px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: "6px",
                }}
              >
                <div className="name_surname">
                  <h3>{d.name}</h3>
                  <h5>{d.designation}</h5>
                </div>
                <div className="linkedin_section">
                  <a href="https://certisured.com/">
                    <img
                      style={{ width: "30px", height: "30px" }}
                      src={linkedin}
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </Wrapper>
  )
}

export default BootcampVideoReview

const Wrapper1 = styled.div`
  grid-area: auto/1/auto/12;
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(11, 1fr);
  grid-template-rows: auto;
  box-sizing: border-box;
  margin: 5rem 0 !important;

  @media (max-width: 767px) {
    margin: 3rem 0 !important;
  }

  .bootcamp_video_review_heading {
    grid-area: 1/2/2/11;
    .fivek_h2 {
      font-weight: 600 !important;
      font-size: 24px !important;

      /* or 150% */
      letter-spacing: 0.02em;

      color: #002f54;
      @media (max-width: 767px) {
        font-size: 20px !important;
      }
    }
  }
  .bootcamp_video_reviews_wrapper {
    grid-area: 2/2/3/11;
    height: auto;
    @media (max-width: 479px) {
      height: auto;
    }
  }
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
  .name_surname {
    display: flex;
    flex-direction: column;
    padding: 0 10px;
  }
  .video_review {
    position: relative;
    padding-top: 56.25%;
    width: 100%;
  }
  .bootcamp_video_reviews_section {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    width: 366.67px;
    height: auto;
    justify-content: center;
  }
  .react-player__preview {
    border-radius: 6px;
    background-repeat: no-repeat;
    box-shadow: 0px 3.01551px 11.3081px rgba(0, 0, 0, 0.15);
    border-radius: 7.53876px;
  }
  h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0px;
    text-align: center;
  }
  h5 {
    font-weight: normal;
    font-size: 11px;
    margin: 0px;
    text-align: center;
  }
  p {
    font-weight: 500;
    font-size: 13px;
    text-align: center;
  }
  a {
    margin-top: 10px;
  }
  .slick-slide img {
    margin: auto;
    align-self: center;
  }
  .slick-slide {
    margin-right: 20px;
    width: 366.67px;
    @media (max-width: 479px) {
      margin-right: 0px;
    }
  }
  .slick-slider {
    display: grid;
    grid-template-columns: repeat(11, 1fr);
  }
  .slick-list {
    grid-area: 1/1/2/12;
  }
  .slick-track {
    display: flex;
    align-items: center;
  }
  .slick-prev::before,
  .slick-next::before {
    color: var(--primaryColor);
    font-size: 40px;
  }
  .slick-next {
    right: 0;
    width: auto;
    height: auto;
    grid-area: 1/11/2/12;
  }
  .slick-prev {
    left: 0;
    z-index: 1;
    width: auto;
    height: auto;
    grid-area: 1/1/2/2;
  }
  .linkedin_section {
    display: flex;
    justify-content: center;
  }
`
